import { gql } from "@apollo/client";

import Race from "../fragments/Race";
import BettingInterests from "../fragments/BettingInterests";
import Video from "../fragments/Video";
import Track from "../fragments/Track";

export const GET_TOP_RACES = gql`
  query getFeaturedRaces(
    $wagerProfile: String
    $brand: String!
    $product: String!
    $device: String!
    $results: Int!
  ) {
    races(
      filter: {
        status: ["O", "IC"]
        allRaceClasses: true
        isTopRace: { product: $product, device: $device, brand: $brand }
      }
      page: { current: 0, results: $results }
      profile: $wagerProfile
      sort: {
        byPinnedOrder: {
          product: $product
          device: $device
          brand: $brand
          order: ASC
        }
      }
    ) {
      ...TopRace
      ...Video
      ...Track
      promos(product: $product, brand: $brand) {
        rootParentPromoID
        isAboveTheLine
        isPromoTagShown
      }
      highlighted(product: $product, device: $device, brand: $brand) {
        description
        style
        pinnedOrder
      }
      bettingInterests(
        filter: { isWagerable: true }
        sort: { byCurrentOdds: ASC }
        page: { current: 0, results: 3 }
      ) {
        ...TopRacesBettingInterests
      }
    }
  }
  ${Race.entry}
  ${BettingInterests.entry}
  ${Video.entry}
  ${Track.entry}
`;

export default GET_TOP_RACES;
